(function () {
  'use strict';

  var banner = document.getElementById('CookieBanner');
  if (!banner) return;

  var customizeBtn = document.getElementById('CookieCustomize');
  var prefsPanel = document.getElementById('CookiePrefs');
  var acceptAllBtn = document.getElementById('CookieAcceptAll');
  var rejectAllBtn = document.getElementById('CookieRejectAll');
  var savePrefsBtn = document.getElementById('CookieSavePrefs');
  var analyticsBox = document.getElementById('ConsentAnalytics');
  var marketingBox = document.getElementById('ConsentMarketing');

  function setConsent(consent) {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      window.Shopify.customerPrivacy.setTrackingConsent(consent, function () {
        banner.hidden = true;
      });
    } else {
      banner.hidden = true;
    }
  }

  function maybeShowBanner() {
    if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.shouldShowBanner && window.Shopify.customerPrivacy.shouldShowBanner()) {
      banner.hidden = false;
    }
  }

  if (acceptAllBtn) {
    acceptAllBtn.addEventListener('click', function () {
      setConsent({ analytics: true, marketing: true, preferences: true, sale_of_data: true });
    });
  }
  if (rejectAllBtn) {
    rejectAllBtn.addEventListener('click', function () {
      setConsent({ analytics: false, marketing: false, preferences: false, sale_of_data: false });
    });
  }
  if (customizeBtn) {
    customizeBtn.addEventListener('click', function () {
      prefsPanel.hidden = !prefsPanel.hidden;
    });
  }
  if (savePrefsBtn) {
    savePrefsBtn.addEventListener('click', function () {
      setConsent({
        analytics: !!(analyticsBox && analyticsBox.checked),
        marketing: !!(marketingBox && marketingBox.checked),
        preferences: true,
        sale_of_data: false
      });
    });
  }

  function init() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      maybeShowBanner();
      return;
    }
    if (!(window.Shopify && window.Shopify.loadFeatures)) return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) maybeShowBanner();
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();
})();
